export enum Routes {
  CREDIT_SIMULATION_INTRO = '/',
  CREDIT_SIMULATION_VALUE = '/value',
  CREDIT_SIMULATION_INSTALLMENTS = '/installments',
  CREDIT_SIMULATION_SUMMARY = '/summary',
  CREDIT_SIMULATION_SELFIE = '/selfie',
  CREDIT_SIMULATION_METHOD = '/method',
  CREDIT_SIMULATION_BANK_ACCOUNT = '/bank-account',
  CREDIT_SIMULATION_PIX_KEY = '/pix-key',
  CREDIT_SIMULATION_PIX_KEY_CONFIRMATION = '/pix-key-confirmation',
  CREDIT_SIMULATION_CONFIRMATION = '/confirmation',
  CREDIT_SIMULATION_WITHDRAWAL_CONFIRMATION = '/withdrawal-confirmation',
  CREDIT_SIMULATION_SUCCESS = '/success',
  ERROR_SCENE = '/error',
  ONBOARDING_INTRO = '/onboarding',
  ONBOARDING_PHONE = '/onboarding/phone',
  ONBOARDING_CEP = '/onboarding/cep',
  ONBOARDING_ADDRESS = '/onboarding/address',
  ONBOARDING_SELFIE = '/onboarding/selfie',
  ONBOARDING_DOC_PHOTO_FRONT = '/onboarding/doc-photo-front',
  ONBOARDING_DOC_PHOTO_BACK = '/onboarding/doc-photo-back',
  ONBOARDING_SIGNATURE = '/onboarding/signature',
  ONBOARDING_CONTRACT = '/onboarding/contract',
  ONBOARDING_CONFIRMATION = '/onboarding/confirmation',
}

export const RoutesHistory = {
  [Routes.CREDIT_SIMULATION_INTRO]: '',
  [Routes.CREDIT_SIMULATION_VALUE]: '',
  [Routes.CREDIT_SIMULATION_INSTALLMENTS]: '',
  [Routes.CREDIT_SIMULATION_SUMMARY]: '',
  [Routes.CREDIT_SIMULATION_SELFIE]: '',
  [Routes.CREDIT_SIMULATION_CONFIRMATION]: '',
  [Routes.CREDIT_SIMULATION_WITHDRAWAL_CONFIRMATION]: '',
  [Routes.CREDIT_SIMULATION_SUCCESS]: '',
  [Routes.ERROR_SCENE]: '',
  [Routes.ONBOARDING_INTRO]: '',
  [Routes.ONBOARDING_PHONE]: '',
  [Routes.ONBOARDING_CEP]: '',
  [Routes.ONBOARDING_ADDRESS]: '',
  [Routes.ONBOARDING_SELFIE]: '',
  [Routes.ONBOARDING_DOC_PHOTO_FRONT]: '',
  [Routes.ONBOARDING_DOC_PHOTO_BACK]: '',
  [Routes.ONBOARDING_SIGNATURE]: '',
  [Routes.ONBOARDING_CONTRACT]: '',
  [Routes.ONBOARDING_CONFIRMATION]: '',
};
